





































import { Vue, Component } from 'vue-property-decorator';

import ConnectSettingsService from '@/api/ConnectSettingsService';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import { ItoggleEvent } from '@/components/Checkbox/CheckBoxTypes';
import { IOption } from './ListItem';
@Component({
  components: {
    Checkbox
  }
})
export default class ConnectSettings extends Vue {
  service = new ConnectSettingsService();
  items: IOption[] = [
    {
      slug: 'rewardCoins',
      name: 'Reward Coins',
      status: 'active',
      checked: true
    },
    {
      slug: 'createCoupons',
      name: 'Allow Coins to be converted into Coupons',
      status: 'active',
      checked: true
    }
  ];
  oauthId = '';
  provider = '';
  loaded = false;
  signupCompleted = true;

  created() {
    this.$showLoaderWithLocker();
    const token = this.$route.query.token as string;
    const oauthId = this.$route.query.oauthId as string;
    const provider = this.$route.query.provider as string;
    if (!oauthId) {
      this.$router.push('/');
      return;
    }

    this.oauthId = oauthId;
    this.provider = provider;

    if (token) {
      this.service.setCredentials(token, false);

      this.service
        .getOptions(this.oauthId)
        .then((response: any) => {
          this.items = this.items.map(item => ({
            ...item,
            checked: response.data.settings[item.slug]
          }));
        })
        .finally(() => {
          this.$hideLoader();
          this.loaded = true;
        });
    } else {
      this.signupCompleted = false;
      this.items = this.items.map(item => ({
        ...item,
        checked: true
      }));
      this.$hideLoader();
      this.loaded = true;
    }
  }

  changeFlagStatus(index: number) {
    const item: IOption = this.items[index];
    item.checked = !item.checked;

    const data = {
      rewardCoins: this.items[0].checked,
      createCoupons: this.items[1].checked
    };

    this.service.changeStatus(this.oauthId, data).then(res => {
      if (!res || res.status !== 200) {
        setTimeout(() => {
          item.checked = !item.checked;
        }, 300);
      }
    });
  }

  isEnabled(status: string) {
    return status === 'enabled';
  }
}
